import {CALL_API} from 'middleware/api';
import * as ActionTypes from '../MakeBet';

function fetchMakeBet(apiData, historyData) {
    return {
        type: ActionTypes.MAKE_BET,
        historyData,
        [CALL_API]: {
            endpoint: '/api/bet/make',
            method: 'post',
            types: [
                ActionTypes.SUCCESS_MAKE_BET,
                ActionTypes.FAILURE_MAKE_BET
            ],
            credentials: true,
            data: apiData
        }
    };
}

export function makeBet(apiData, historyData) {
    return (dispatch) => {
        return dispatch(fetchMakeBet(apiData, historyData));
    };
}



// WEBPACK FOOTER //
// ./js/actions/creators/MakeBet.js